var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDefine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.29 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.57,0h5.86a.86.86,0,0,1,.86.86V5.57a.86.86,0,0,1-.86.86H11.57a.86.86,0,0,1-.86-.86V.86A.86.86,0,0,1,11.57,0ZM6.71,0H.86A.86.86,0,0,0,0,.86V5.57a.86.86,0,0,0,.86.86H6.71a.86.86,0,0,0,.86-.86V.86A.86.86,0,0,0,6.71,0ZM0,10.43v4.71A.86.86,0,0,0,.86,16H6.71a.86.86,0,0,0,.86-.86V10.43a.86.86,0,0,0-.86-.86H.86A.86.86,0,0,0,0,10.43ZM11.57,16h5.86a.86.86,0,0,0,.86-.86V10.43a.86.86,0,0,0-.86-.86H11.57a.86.86,0,0,0-.86.86v4.71A.86.86,0,0,0,11.57,16Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDefine);
export default __webpack_public_path__ + "static/media/icon-define.0a34982f320ad6abef2aa83f3e35ac66.svg";
export { ForwardRef as ReactComponent };